<h1 mat-dialog-title>Add New Collection</h1>
<div mat-dialog-content [formGroup]="addCollectionForm">
  <mat-form-field appearance="outline" color="accent" class="name-input" required>
    <mat-label>Name</mat-label>
    <input matInput formControlName="name" />
  </mat-form-field>
  <br />
  <mat-form-field appearance="outline" color="accent" class="description-input">
    <mat-label>Description</mat-label>
    <textarea matInput formControlName="description"></textarea>
  </mat-form-field>

  <div class="collection-context form-group">
    <mat-label>Collection Type</mat-label>
    <mat-radio-group aria-label="Select a collection type" formControlName="context">
      <mat-radio-button value="regulatory">Regulatory</mat-radio-button>
      <mat-radio-button value="rfp">RFP/Grant</mat-radio-button>
    </mat-radio-group>
  </div>
  <div class="private form-group">
    <mat-label>Is this collection private?</mat-label>
    <mat-checkbox formControlName="is_private" color="accent">Private</mat-checkbox>
  </div>
  <mat-form-field
    appearance="outline"
    *ngIf="addCollectionForm.get('is_private')?.value"
    color="accent"
    class="access-list">
    <mat-label>Access List</mat-label>
    <mat-chip-grid #chipGrid aria-label="Access List">
      <mat-chip-row *ngFor="let user_id of accessList.value" [removable]="true" (removed)="removeAccess(user_id)">
        {{ getEmail(user_id) }}
        <mat-icon matChipRemove>cancel</mat-icon>
      </mat-chip-row>
      <input
        #chipInput
        placeholder="Search for users..."
        [matChipInputFor]="chipGrid"
        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
        [formControl]="searchControl"
        [matAutocomplete]="auto"
        (matChipInputTokenEnd)="addAccessFromInput($event)" />
    </mat-chip-grid>
    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="addAccess($event)" [displayWith]="displayUser">
      <mat-option *ngFor="let user of filteredUsers$ | async" [value]="user">
        {{ user.email }}
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>

  <h3>Dimensions</h3>
  <button mat-raised-button color="accent" (click)="addDimension()">Add Dimension</button>
  <div formArrayName="dimensions" class="dimensions-container">
    <div *ngFor="let dimension of dimensions.controls; let i = index" [formGroupName]="i" class="dimension-form-group">
      <mat-form-field appearance="outline" color="accent" class="dimension-name">
        <mat-label>Dimension Name</mat-label>
        <input matInput formControlName="name" />
      </mat-form-field>
      <mat-form-field appearance="outline" color="accent" class="dimension-description">
        <mat-label>Dimension Description</mat-label>
        <input matInput formControlName="description" />
      </mat-form-field>
      <div class="controls">
        <button mat-icon-button (click)="removeDimension(i)" color="accent">
          <mat-icon>delete</mat-icon>
        </button>
        <mat-slide-toggle formControlName="show_advisor_filter">Advisor Filter</mat-slide-toggle>
      </div>
    </div>
  </div>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="onNoClick()">Cancel</button>
  <button mat-raised-button [disabled]="isDirty" color="accent" (click)="saveForm()">Save</button>
</div>
